/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/adm-notification-gestor'

export default {
    get: params => {
        let customRoute = `${route}?expand=user,tipo,status_description&search=${params.filter}`
        switch (params.notificacionEstado) {
            case "2": customRoute = `${route}?estado=1&expand=user,tipo,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?estado=0&expand=user,tipo,status_description&search=${params.filter}`
                break;
            case "6": customRoute = `${route}?${params.customfilter}&expand=user,tipo,status_description&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getAll: () => Api().get(`${route}?estado=1`, { crossDomain: true }),
    getAllRecords: () => Api().get(`${route}?fields=id,nombre&expand=user,tipo,status_description`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=user,tipo,status_description`, payload),
    put: payload => Api().put(`${route}/${payload.id}?expand=user,tipo,status_description`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=user,tipo,status_description`)
}
